<template>
  <div class="page-inner r" style="min-height: 100vh">
    <div class="page-title">
      <h3>{{ $t("message.Статистика") }}</h3>
      <div class="page-breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/">{{ $t("message.Главная") }}</router-link>
          </li>
          <li class="active breadcrumb-item">{{ $t("message.Статистика") }}</li>
        </ol>
      </div>
    </div>

    <div id="main-wrapper" v-if="!hasReadPermissions">
      {{ $t("message.Нет_прав_доступа_на_чтение") }}
    </div>
    <div id="main-wrapper" v-if="hasReadPermissions">
      <b-row>
        <b-col>
          <h4>{{ loading }}</h4>
        </b-col>
      </b-row>

      <b-card-group deck>
        <b-card border-variant="primary" style="max-width: 1300px">
          <h4>
            Report 1: Статистика уникальных сессий по каналу за сутки за каждый
            час для LIVE и DVR
          </h4>
          <b-row>
            <b-col class="col-3">
              <b-form-group label="Date:" label-for="Date">
                <date-picker
                  v-model="curDate"
                  class="float-left mb-3"
                  :lang="lang"
                  :format="'DD.MM.YYYY'"
                  :clearable="false"
                ></date-picker>
              </b-form-group>
            </b-col>
            <b-col class="col-3">
              <b-form-group label="" label-for="">
                <b-button
                  :variant="'success'"
                  class="float-left mb-3"
                  @click="createStatistics()"
                  >{{ $t("message.Статистика_Создание_Отчета") }}
                </b-button>
              </b-form-group>
            </b-col>
            <b-col class="col-3">
              <b-form-group label="" label-for="">
                <b-link :to="fields.url_redirect">
                  <h4>{{ fields.file_name }}</h4>
                </b-link>
              </b-form-group>
            </b-col>
          </b-row>
        </b-card>
      </b-card-group>

      <b-card-group deck>
        <b-card border-variant="primary" style="max-width: 1300px">
          <h4>
            Report 2: Уникальные логины за период по каналу/по всем каналам
          </h4>
          <b-row>
            <b-col class="col-3">
              <b-form-group label="Date From:" label-for="Date">
                <date-picker
                  v-model="curDateFrom"
                  class="float-left mb-3"
                  :lang="lang"
                  :format="'DD.MM.YYYY'"
                  :clearable="false"
                ></date-picker>
              </b-form-group>
            </b-col>
            <b-col class="col-3">
              <b-form-group label="Date To:" label-for="Date">
                <date-picker
                  v-model="curDateTo"
                  class="float-left mb-3"
                  :lang="lang"
                  :format="'DD.MM.YYYY'"
                  :clearable="false"
                ></date-picker>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="col-3">
              <b-form-group label="Channel:" label-for="Channel">
                <v-select
                  @input="selectId($event)"
                  :options="channels"
                  label="name"
                >
                </v-select>
              </b-form-group>
            </b-col>
            <b-col class="col-3">
              <b-form-group label="Partner:" label-for="Partner2">
                <v-select
                  @input="selectId_Partners2($event)"
                  :options="partners2"
                  label="username"
                >
                </v-select>
              </b-form-group>
            </b-col>
            <b-col class="col-3">
              <b-form-group label="" label-for="">
                <b-button
                  :variant="'success'"
                  class="float-left mb-3"
                  @click="createStatistics2()"
                  >{{ $t("message.Статистика_Создание_Отчета") }}
                </b-button>
              </b-form-group>
            </b-col>
            <b-col class="col-3">
              <b-form-group label="" label-for="">
                <b-link :href="fields2.url_redirect">
                  <h4>{{ fields2.file_name }}</h4>
                </b-link>
              </b-form-group>
            </b-col>
          </b-row>
        </b-card>
      </b-card-group>
      <b-card-group deck>
        <b-card border-variant="primary" style="max-width: 1300px">
          <h4>Report 3: Статистика по Партнерам по Типам Аккаунтов</h4>
          <b-row>
            <b-col class="col-3">
              <b-form-group label="Date From:" label-for="Date">
                <date-picker
                  v-model="curDateFrom3"
                  class="float-left mb-3"
                  :lang="lang"
                  :format="'DD.MM.YYYY'"
                  :clearable="false"
                ></date-picker>
              </b-form-group>
            </b-col>
            <b-col class="col-3">
              <b-form-group label="Date To:" label-for="Date">
                <date-picker
                  v-model="curDateTo3"
                  class="float-left mb-3"
                  :lang="lang"
                  :format="'DD.MM.YYYY'"
                  :clearable="false"
                ></date-picker>
              </b-form-group>
            </b-col>
            <b-col class="col-3">
              <b-form-group label="" label-for="">
                <b-button
                  :variant="'success'"
                  class="float-left mb-3"
                  @click="createStatistics3()"
                  >{{ $t("message.Статистика_Создание_Отчета") }}
                </b-button>
              </b-form-group>
            </b-col>
            <b-col class="col-3">
              <b-form-group label="" label-for="">
                <b-link :href="fields3.url_redirect">
                  <h4>{{ fields3.file_name }}</h4>
                </b-link>
              </b-form-group>
            </b-col>
          </b-row>
        </b-card>
      </b-card-group>

      <b-card-group deck>
        <b-card border-variant="primary" style="max-width: 1300px">
          <h4>
            Report 3: Статистика по Партнерам по Типам Аккаунтов с учетом
            истории изменения Enabled (с 27.09.2021 по 09.11.2021)
          </h4>
          <b-row>
            <b-col class="col-3">
              <b-form-group label="Date From:" label-for="Date">
                <date-picker
                  v-model="curDateFrom3_2"
                  class="float-left mb-3"
                  :lang="lang"
                  :format="'DD.MM.YYYY'"
                  :clearable="false"
                ></date-picker>
              </b-form-group>
            </b-col>
            <b-col class="col-3">
              <b-form-group label="Date To:" label-for="Date">
                <date-picker
                  v-model="curDateTo3_2"
                  class="float-left mb-3"
                  :lang="lang"
                  :format="'DD.MM.YYYY'"
                  :clearable="false"
                ></date-picker>
              </b-form-group>
            </b-col>
            <b-col class="col-3">
              <b-form-group label="" label-for="">
                <b-button
                  :variant="'success'"
                  class="float-left mb-3"
                  @click="createStatistics3_2()"
                  >{{ $t("message.Статистика_Создание_Отчета") }}
                </b-button>
              </b-form-group>
            </b-col>
            <b-col class="col-3">
              <b-form-group label="" label-for="">
                <b-link :href="fields3_2.url_redirect">
                  <h4>{{ fields3_2.file_name }}</h4>
                </b-link>
              </b-form-group>
            </b-col>
          </b-row>
        </b-card>
      </b-card-group>

      <b-card-group deck>
        <b-card border-variant="primary" style="max-width: 1300px">
          <h4>
            Report 3: Статистика по Партнеру за период / Enabled и SUBSCRIBER и
            Activated_at до Правой даты включительно / с учетом аудита истории
            изменений (с 01.11.2021 - н.в.)
          </h4>
          <b-row>
            <b-col class="col-3">
              <b-form-group label="Date From:" label-for="Date">
                <date-picker
                  v-model="curDateFrom3_3"
                  class="float-left mb-3"
                  :lang="lang"
                  :format="'DD.MM.YYYY'"
                  :clearable="false"
                ></date-picker>
              </b-form-group>
            </b-col>
            <b-col class="col-3">
              <b-form-group label="Date To:" label-for="Date">
                <date-picker
                  v-model="curDateTo3_3"
                  class="float-left mb-3"
                  :lang="lang"
                  :format="'DD.MM.YYYY'"
                  :clearable="false"
                ></date-picker>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col class="col-3">
              <b-form-group label="Partner:" label-for="Partner">
                <v-select
                  @input="selectId_Partners3($event)"
                  :options="partners3"
                  label="username"
                >
                </v-select>
              </b-form-group>
            </b-col>

            <b-col>
              <b-form-group
                label="Activated up to Date_To:"
                label-for="Activated"
              >
                <b-form-checkbox
                  v-model="activated3"
                  id="Enabled"
                  switch
                ></b-form-checkbox>
              </b-form-group>
            </b-col>

            <b-col class="col-3">
              <b-form-group label="" label-for="">
                <b-button
                  :variant="'success'"
                  class="float-left mb-3"
                  @click="createStatistics3_3()"
                  >{{ $t("message.Статистика_Создание_Отчета") }}
                </b-button>
              </b-form-group>
            </b-col>
            <b-col class="col-3">
              <b-form-group label="" label-for="">
                <b-link :href="fields3_3.url_redirect">
                  <h4>{{ fields3_3.file_name }}</h4>
                </b-link>
              </b-form-group>
            </b-col>
          </b-row>
        </b-card>
      </b-card-group>

      <b-card-group deck>
        <b-card border-variant="primary" style="max-width: 1300px">
          <h4>Report 4: Аккаунты Партнера</h4>
          <b-row>
            <b-col class="col-3">
              <b-form-group label="Date From:" label-for="Date">
                <date-picker
                  v-model="curDateFrom4"
                  class="float-left mb-3"
                  :lang="lang"
                  :format="'DD.MM.YYYY'"
                  :clearable="false"
                ></date-picker>
              </b-form-group>
            </b-col>
            <b-col class="col-3">
              <b-form-group label="Date To:" label-for="Date">
                <date-picker
                  v-model="curDateTo4"
                  class="float-left mb-3"
                  :lang="lang"
                  :format="'DD.MM.YYYY'"
                  :clearable="false"
                ></date-picker>
              </b-form-group>
            </b-col>

            <b-col class="col-3">
              <b-form-group label="Partner:" label-for="Partner">
                <v-select
                  @input="selectId_Partners($event)"
                  :options="partners"
                  label="username"
                >
                </v-select>
              </b-form-group>
            </b-col>

            <b-col class="col-3">
              <b-form-group label="" label-for="">
                <b-button
                  :variant="'success'"
                  class="float-left mb-3"
                  @click="createStatistics4()"
                  >{{ $t("message.Статистика_Создание_Отчета") }}
                </b-button>
              </b-form-group>
            </b-col>
            <b-col class="col-3">
              <b-form-group label="" label-for="">
                <b-link :href="fields4.url_redirect">
                  <h4>{{ fields4.file_name }}</h4>
                </b-link>
              </b-form-group>
            </b-col>
          </b-row>
        </b-card>
      </b-card-group>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import DatePicker from "vue2-datepicker";

export default {
  name: "StatisticsChannelsBySessionsByDate",
  components: { DatePicker },
  data() {
    return {
      curDate: "",
      lang: "ru",
      loading: "",
      fields: {},

      curDateFrom: "",
      curDateTo: "",
      channels: [],
      partners2: [],
      fields2: {},

      curDateFrom3: "",
      curDateTo3: "",
      fields3: {},

      curDateFrom3_2: "",
      curDateTo3_2: "",
      fields3_2: {},

      curDateFrom3_3: "",
      curDateTo3_3: "",
      partners3: [],
      fields3_3: {},

      curDateFrom4: "",
      curDateTo4: "",
      partners: [],
      fields4: {},

      selected: "",
      selected_Partners: "",

      selected2: "",
      selected_Partners2: "",

      selected3: "",
      selected_Partners3: "",
      activated3: false
    };
  },
  computed: {
    hasReadPermissions: function() {
      return !!this.$storage
        .get("current_user")
        .permissions.filter(value => value == "statistics:fully_manage").length;
    }
  },
  created: function() {
    this.curDate = new Date().getTime();

    this.curDateFrom = new Date().getTime();
    this.curDateTo = new Date().getTime();
    let channels = this.$noname.get("channels_select", {
      params: { perPage: 10000 }
    });
    let partners2 = this.$noname.get("users", { params: { perPage: 10000 } });

    this.curDateFrom3 = new Date().getTime();
    this.curDateTo3 = new Date().getTime();

    this.curDateFrom3_2 = new Date().getTime();
    this.curDateTo3_2 = new Date().getTime();

    this.curDateFrom3_3 = new Date().getTime();
    this.curDateTo3_3 = new Date().getTime();
    let partners3 = this.$noname.get("users", { params: { perPage: 10000 } });
    this.activated3 = false;

    this.curDateFrom4 = new Date().getTime();
    this.curDateTo4 = new Date().getTime();
    let partners = this.$noname.get("users", { params: { perPage: 10000 } });

    channels
      .then(data => {
        this.channels = data.data.items;
        // console.log("channels = " + this.channels[0].name)
      })
      .catch(error => {
        Vue.notify({
          group: "notify",
          text:
            this.$i18n.t(
              "message.Не_удалось_получить_список_каналов_источников"
            ) +
            ":<br>" +
            error,
          type: "error"
        });
      });

    partners
      .then(data => {
        this.partners = data.data.items;
      })
      .catch(error => {
        Vue.notify({
          group: "notify",
          text:
            this.$i18n.t("message.Не_удалось_получить_список_мемберов") +
            ":<br>" +
            error,
          type: "error"
        });
      });

    partners2
      .then(data => {
        this.partners2 = data.data.items;
      })
      .catch(error => {
        Vue.notify({
          group: "notify",
          text:
            this.$i18n.t("message.Не_удалось_получить_список_мемберов") +
            ":<br>" +
            error,
          type: "error"
        });
      });

    partners3
      .then(data => {
        this.partners3 = data.data.items;
      })
      .catch(error => {
        Vue.notify({
          group: "notify",
          text:
            this.$i18n.t("message.Не_удалось_получить_список_мемберов") +
            ":<br>" +
            error,
          type: "error"
        });
      });
  },
  methods: {
    createStatistics: function() {
      this.loading = "LOADING...";

      this.fields = {};
      let promise = this.$noname.getChild(
        "statistics",
        "channels_report_by_date",
        this.$moment(this.curDate).format("DDMMYY")
      );
      return promise.then(response => {
        Vue.notify({
          group: "notify",
          text: this.$i18n.t("message.Статистика_Отчет_Готов"),
          type: "success"
        });
        this.loading = "";
        this.fields = response.data;
        // console.log("fields.url_redirect=" + this.fields.url_redirect)
        window.location.href = this.fields.url_redirect;
      });
    },
    createStatistics2: function() {
      this.loading = "LOADING...";

      // console.log("From = "     + this.$moment(this.curDateFrom).format("DDMMYY") + " | " +
      //             "To = "       + this.$moment(this.curDateTo).format("DDMMYY") + " | " +
      //             "Channel = "  + this.selected)

      this.fields2 = {};
      let promise = this.$noname.get("statistics_unique_accounts", {
        params: {
          dateFrom: this.$moment(this.curDateFrom).format("DDMMYY"),
          dateTo: this.$moment(this.curDateTo).format("DDMMYY"),
          channel: this.selected != "" ? this.selected : "",
          partner: this.selected_Partners2 != "" ? this.selected_Partners2 : ""
        }
      });

      return promise.then(response => {
        Vue.notify({
          group: "notify",
          text: this.$i18n.t("message.Статистика_Отчет_Готов"),
          type: "success"
        });
        this.loading = "";
        this.fields2 = response.data;
        // console.log("this.fields2.url_redirect=" + this.fields2.url_redirect)
        window.location.href = this.fields2.url_redirect;
      });
    },
    selectId(e) {
      if (e) {
        // console.log("e.id=" + e.id)
        this.selected = e.id;
      } else {
        this.selected = "";
      }
    },

    createStatistics3: function() {
      this.loading = "LOADING...";

      // console.log("From = "     + this.$moment(this.curDateFrom).format("DDMMYY") + " | " +
      //            "To = "       + this.$moment(this.curDateTo).format("DDMMYY") + " | " +
      //            "Channel = "  + this.selected)

      this.fields3 = {};
      let promise = this.$noname.get("statistics_partners_count_by_types", {
        params: {
          dateFrom: this.$moment(this.curDateFrom3).format("DDMMYY"),
          dateTo: this.$moment(this.curDateTo3).format("DDMMYY")
        }
      });

      return promise.then(response => {
        Vue.notify({
          group: "notify",
          text: this.$i18n.t("message.Статистика_Отчет_Готов"),
          type: "success"
        });
        this.loading = "";
        this.fields3 = response.data;
        // console.log("this.fields3.url_redirect=" + this.fields3.url_redirect)
        window.location.href = this.fields3.url_redirect;
      });
    },

    createStatistics3_2: function() {
      this.loading = "LOADING...";

      this.fields3_2 = {};
      let promise = this.$noname.get(
        "statistics_partners_count_by_types_historical",
        {
          params: {
            dateFrom: this.$moment(this.curDateFrom3_2).format("DDMMYY"),
            dateTo: this.$moment(this.curDateTo3_2).format("DDMMYY")
          }
        }
      );

      return promise.then(response => {
        Vue.notify({
          group: "notify",
          text: this.$i18n.t("message.Статистика_Отчет_Готов"),
          type: "success"
        });
        this.loading = "";
        this.fields3_2 = response.data;
        // console.log("this.fields3.url_redirect=" + this.fields3.url_redirect)
        window.location.href = this.fields3_2.url_redirect;
      });
    },

    createStatistics3_3: function() {
      this.loading = "LOADING...";

      this.fields3_3 = {};
      let promise = this.$noname.get(
        "statistics_partners_count_by_types_historical_v3",
        {
          params: {
            dateFrom: this.$moment(this.curDateFrom3_3).format("DDMMYY"),
            dateTo: this.$moment(this.curDateTo3_3).format("DDMMYY"),
            partner:
              this.selected_Partners3 != "" ? this.selected_Partners3 : "0",
            activated: this.activated3
          }
        }
      );

      return promise.then(response => {
        Vue.notify({
          group: "notify",
          text: this.$i18n.t("message.Статистика_Отчет_Готов"),
          type: "success"
        });
        this.loading = "";
        this.fields3_3 = response.data;
        // console.log("this.fields3.url_redirect=" + this.fields3.url_redirect)
        window.location.href = this.fields3_3.url_redirect;
      });
    },

    selectId_Partners(e) {
      if (e) {
        // console.log("e.id=" + e.id)
        // console.log("e.username=" + e.username)
        this.selected_Partners = e.username;
      } else {
        this.selected_Partners = "";
      }
    },

    selectId_Partners2(e) {
      if (e) {
        // console.log("e.id=" + e.id)
        // console.log("e.username=" + e.username)
        this.selected_Partners2 = e.username;
      } else {
        this.selected_Partners2 = "";
      }
    },

    selectId_Partners3(e) {
      if (e) {
        // console.log("e.id=" + e.id)
        // console.log("e.username=" + e.username)
        this.selected_Partners3 = e.username;
      } else {
        this.selected_Partners3 = "";
      }
    },

    createStatistics4: function() {
      this.loading = "LOADING...";

      // console.log("From = "     + this.$moment(this.curDateFrom4).format("DDMMYY") + " | " +
      //             "To = "       + this.$moment(this.curDateTo4).format("DDMMYY") + " | " +
      //             "Partners = " + this.selected_Partners)

      this.fields4 = {};
      let promise = this.$noname.get(
        "statistics_accounts_by_partner_and_by_dates",
        {
          params: {
            dateFrom: this.$moment(this.curDateFrom4).format("DDMMYY"),
            dateTo: this.$moment(this.curDateTo4).format("DDMMYY"),
            partner: this.selected_Partners != "" ? this.selected_Partners : "0"
          }
        }
      );

      return promise.then(response => {
        Vue.notify({
          group: "notify",
          text: this.$i18n.t("message.Статистика_Отчет_Готов"),
          type: "success"
        });
        this.loading = "";
        this.fields4 = response.data;
        // console.log("this.fields4.url_redirect=" + this.fields3.url_redirect)
        window.location.href = this.fields4.url_redirect;
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/modules/StatisticsChannelsBySessionsByDate.vue